import { useStorage } from '@vueuse/core';
import { createStorage } from 'unstorage';
import memoryDriver from 'unstorage/drivers/memory';

// create a localstorage store when in the browser, otherwise a memory driver using unstorage.
const storage = window?.sessionStorage ? window.sessionStorage : createStorage({ driver: memoryDriver() });
export const quickscanTimeline = useStorage('QuickscanTimeline', [], storage);
